import { makeStyles } from 'tss-react/mui'


export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            background: theme.palette.background.paper
        },
        tab: {
            fontSize: "14px",
            padding: theme.spacing(0, 2)
        },
        disabled: {
            cursor: 'default'
        }
    }
})